export default __webpack_public_path__ + "static/media/image-087.73beb7e8.jpeg";